import { useMemo } from "react";

import { useTrack } from "pro-features/components/WithTrack/src/useTrack";

import createEmployeeProfilesTrackingService from "../services/tracking/factory";

export const useEmployeeProfilesTrackingService = () => {
    const [track] = useTrack();

    return useMemo(() => createEmployeeProfilesTrackingService(track), [track]);
};
